import { decodeJWT } from "../library";

export const isTokenExpired = (token: string): boolean => {
  try {
    const { exp } = decodeJWT(token);
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};

export const isTokenAboutToExpire = (
  token: string,
  bufferMs: number = 60000,
): boolean => {
  try {
    const { exp } = decodeJWT(token);
    return Date.now() >= exp * 1000 - bufferMs;
  } catch {
    return true;
  }
};
